const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '')

function buildApiUrl(path) {
  if (!API_BASE_URL || /^https?:\/\//i.test(path)) return path
  return `${API_BASE_URL}${path}`
}

export async function fetchPublic(url, options = {}) {
  const isFormData = options.body instanceof FormData
  const res = await fetch(buildApiUrl(url), {
    credentials: 'include',
    ...options,
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(API_BASE_URL.includes('ngrok') ? { 'ngrok-skip-browser-warning': 'true' } : {}),
      ...(options.headers || {}),
    },
  })
  const data = await res.json().catch(() => null)
  if (!res.ok) {
    const err = new Error(data?.message || `HTTP ${res.status}`)
    err.status = res.status
    throw err
  }
  return data
}
